import { transferConstants } from '../_constants/transfer.constants';

const initialState = {
  // Modal State 
  isOpenModal: false
};

const transferReducer = (state = initialState, action) => {
  switch (action.type) {
    case transferConstants.TOGGLED_TRANSFER_MODAL:
      return {
        ...state,
        isOpenModal: !state.isOpenModal
        //fundId: state.isOpenModal ? null : state.fundId
      };
    default:
      return state;
  }
};

export default transferReducer;
